import { firestoreDB } from '../firebase'

const firebaseEtiquetaCollection = 'etiqueta'

const guardarNuevaEtiqueta = Nombre =>
  firestoreDB
    .collection(firebaseEtiquetaCollection)
    .doc(Nombre.toLowerCase())
    .set({ Nombre })

const obtenerEtiquetas = () => firestoreDB.collection(firebaseEtiquetaCollection).get()

const obtenerEtiqueta = id =>
  firestoreDB
    .collection(firebaseEtiquetaCollection)
    .doc(id)
    .get()

export const firebaseEtiquetasRepository = {
  guardarNuevaEtiqueta,
  obtenerEtiquetas,
  obtenerEtiqueta,
}
